var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPerson = function SvgPerson(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M9.65 3.016a2.333 2.333 0 1 1-3.3 3.3 2.333 2.333 0 0 1 3.3-3.3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M2.667 12.333v.666c0 .368.298.667.666.667h9.334a.667.667 0 0 0 .666-.667v-.666c0-2.017-2.634-3.328-5.333-3.328-2.699 0-5.333 1.31-5.333 3.328",
    clipRule: "evenodd"
  })));
};
export { SvgPerson as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiNTY2MDg0MWU4ZTA0NWFlMTEzMzhiNTYxMjk5NzI2NDcuc3ZnIjs=";